module.exports = __webpack_public_path__ + "img/icon-1.f38a1068.png";